import { CountryBox } from '../../country-box.component'
import { getFieldTestId } from '../field-helpers'
import type { FieldRenderer } from '../types'

const renderCountryReadonlyField: FieldRenderer = ({ field, ctx, t }) => {
    const key = field.key
    return (
        <CountryBox
            key={key}
            label={t(field.label)}
            value={ctx.countryDisplayName ?? (ctx.form[key] as string) ?? ''}
            flagUrl={ctx.countryFlagUrl}
            inputTestId={getFieldTestId(ctx, key, 'input')}
            data-testid={getFieldTestId(ctx, key, 'country-box')}
        />
    )
}

renderCountryReadonlyField.areCtxEqual = (a, b) => a.countryDisplayName === b.countryDisplayName && a.countryFlagUrl === b.countryFlagUrl

export default renderCountryReadonlyField
